module.exports = "https://assets.calmac.co.uk/scripts/apps/overlays/1.8/img/clock.svg";